import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchHealthFacilities, importHealthFacilities } from '../redux/HealthFacilitiesSlice';
import { toast } from 'react-toastify';

const ImportFacilities = ({ onClose }) => {
    const dispatch = useDispatch();
    const [importing, setImporting] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'text/csv') {
            setSelectedFile(file);
        } else {
            toast.error('Please select a valid CSV file');
        }
    };

    const handleImport = async () => {
        if (!selectedFile) {
            toast.error('Please select a file first');
            return;
        }

        try {
            setImporting(true);
            await dispatch(importHealthFacilities(selectedFile)).unwrap();
            toast.success('Facilities imported successfully');
            // Optionally refresh the facilities list
            dispatch(fetchHealthFacilities({ page: 1, limit: 15 }));
            setSelectedFile(null);
            // Reset file input
            const fileInput = document.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = '';
        } catch (error) {
            const errorMessage = error?.error || error?.message || 'Failed to import facilities';
            toast.error(errorMessage);
        } finally {
            setImporting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-full mx-6 lg:max-w-md">
                <h2 className="text-xl font-bold mb-4">
                    Import File
                </h2>
                <p>Kindly import csv file</p>
                <div className="space-y-4 mt-6">
                    <div>
                        <input
                            type="file"
                            accept=".csv"
                            onChange={handleFileChange}
                            disabled={importing}
                            className="block w-full text-sm text-gray-500
            file:mr-4 file:py-2 file:px-4
            file:rounded-md file:border-0
            file:text-sm file:font-semibold
            file:bg-blue-50 file:text-blue-700
            hover:file:bg-blue-100"
                        />
                    </div>

                    <div className='flex justify-end gap-2 items-center'>
                    <button
                        onClick={handleImport}
                        disabled={!selectedFile || importing}
                        className={`px-4 py-2 rounded-md text-white font-medium
          ${importing || !selectedFile
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-blue-600 hover:bg-blue-700'}`}
                    >
                        {importing ? 'Importing...' : 'Import Facilities'}
                    </button>
                    <button
                    className='bg-gray-50 py-2 px-4 rounded-md font-medium'
                    onClick={onClose}>
                        Cancel
                    </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImportFacilities;